import { render, staticRenderFns } from "./instructorsModal.vue?vue&type=template&id=0fad1ec0&scoped=true&"
import script from "./instructorsModal.vue?vue&type=script&lang=js&"
export * from "./instructorsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fad1ec0",
  null
  
)

export default component.exports